export const PATIENT_TYPE_ID = 'patient-type-field';
export const TIME_ID = 'requested-time-field';
export const LOCATION_ID = 'location-select-field';
export const REASON_ID = 'reason-for-visit-field';
export const INSURANCE_NAME_ID = 'insurance-name-field';
